module.exports = __webpack_public_path__ + "img/test4.75dcac41.jpg";